import SurveysSerializer from './base';

export default class Response extends SurveysSerializer {}
